import React from 'react';
import { useReveal } from '../lib/useReveal';
const POINTS = ['Principiantes', 'Emprendedoras', 'Personas que quieren vender desde casa', 'Pasteleras que quieren mejorar estética', 'Personas que quieren aprender a decorar'];
export function AudienceSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-[#fce7e9]/40" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <div ref={ref} className={`reveal bg-white rounded-[2.5rem] p-6 md:p-10 shadow-[0_20px_50px_rgba(232,154,170,0.08)] border border-[#f4b6c2]/40 ${isVisible ? 'is-visible' : ''}`} data-id="element-19">
          <div className="text-center mb-6" data-id="element-20">
            <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-21">
              ♡ Para Vos ♡
            </span>
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a]" data-id="element-22">
              ¿Para quién es{' '}
              <span className="italic text-[#e89aaa]" data-id="element-23">este MegaPack?</span>
            </h2>
          </div>

          <div className="space-y-3" data-id="element-24">
            {POINTS.map((point, i) => <div key={i} className="flex items-center gap-3" data-id="element-25">
                <div className="w-7 h-7 rounded-full bg-[#fdf2f4] flex items-center justify-center shrink-0 border border-[#f4b6c2]/40" data-id="element-26">
                  <span className="text-[#e89aaa] text-sm" data-id="element-27">✓</span>
                </div>
                <p className="text-[#6b4f3a] text-base md:text-lg font-medium" data-id="element-28">
                  {point}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}